import BaseService from './BaseService';


class ProviderService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/provider";
	}
	getProviderCF() {
		const url = this.serviceUrl + "/findProviderCF?providerCode=" + provider;
		return this.opencellAPI.callApi(url);
	}
}

const providerService = new ProviderService();
export default providerService;



// WEBPACK FOOTER //
// ./src/opencell/services/ProviderService.js